<template>
  <ForbiddenError>
    <template #hat="{ hat }">
      <p class="text-h1">
        {{ hat }}
      </p>
    </template>
  </ForbiddenError>
</template>

<script setup lang="ts">
import { ForbiddenError } from "@pasta/box-v2";
</script>
